import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-50 dark:bg-gray-900" }

import AppNav from '@/components/navs/AppNav/AppNav.vue';
import useBreakpoints from '@/composables/useBreakpoints';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isMobile } = useBreakpoints();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "app-body",
      style: _normalizeStyle(_unref(isMobile) ? { display: 'block' } : {})
    }, [
      _createVNode(AppNav),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_view, {
          key: _ctx.$route.path
        })
      ])
    ], 4)
  ]))
}
}

})